import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from "axios";

import CustomDropDown from '../Common/customDropDown';

function ABSelect(props) {

  //Handling TP Dropdown
  const tpDropdown = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({});

  const handleThirdPartyFloatingLabel = (e) => {
    let parent = e.target.parentElement;
    while (!parent.classList.contains('floating-label'))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains('focused')) {
      if (currentSelectedVal !== null || value) {
        return false;
      } else {
        parent.children[1].classList.remove('focused');
        setCurrentSelectedVal(null);
      }
    } else {
      parent.children[1].classList.add('focused');
    }
  }
  const { type, options, attachOther, verificationType, name, id, placeholder, fieldId, isRequired, errId, caseCheckId, returnType, value, hiddenValue, selectedLabel } = props;
  const [currentSelectedVal, setCurrentSelectedVal] = useState(null);
  const [reactSelect, setReactSelect] = useState();
  useEffect(() => {
    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }
    setReactSelect({ value: value, label: stateValue });
  }, []);

  useEffect(() => {
    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }

    setFormData(() => ({
      [name + "_value"]: hiddenValue,
    }));


  }, [hiddenValue]);

  const handleChange = (selectedOption) => {
    setCurrentSelectedVal(selectedOption.target.value);
    setReactSelect(selectedOption);
    let value = selectedOption.target.value;
    if (returnType === 'name') {
      value = selectedOption.name;
    }
    setFormData((prevState) => ({
      [name + "_value"]: selectedOption.target.value,
    }));
    props.selectOption([{ "name": name, "value": value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId }]);
  };

  let classNameD=props.pageName;
  let finalClassName="";
  if(classNameD=="Professional License"){
    finalClassName="col-sm-11 col-md-12 col-xl-11";
  } else{
    finalClassName="col-sm-4 col-md-12 col-xl-4";
  }
  return (
    <>
      <div className={finalClassName}>
        <div className="form-group">
          <div className="floating-label tp-dropdown" ref={tpDropdown}>
            <select
              onChange={(e) => handleChange(e)}
              name={name}
              id={name}
              className="form-control"
              onFocus={handleThirdPartyFloatingLabel}
              onBlur={handleThirdPartyFloatingLabel}
            >
            <option value=""></option>
            {options &&
              Object.entries(options).map((option) => {
                return (
                  <option
                    value={option[0]}
                    selected={value == option[0] ? true : false}
                  >
                    {option[1]}
                  </option>
                );
              })}
            </select>
            <label htmlFor={id} className={(value) && 'focused'}>{placeholder} {isRequired == 1 && <sup className="text-danger">*</sup>}</label>
          </div>
          <p className="err text-danger" id={errId}></p>
          <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />
        </div>
      </div>
    </>
  );
}

export default ABSelect;
